import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppNavigationComponent } from '@layout/app-navigation/app-navigation.component';
import { LayoutService } from '@shared/services';
import { AppRoutesEnum } from '@shared/types';
import { DrawerComponent } from '@ui-kit/miscs';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: true,
    imports: [DrawerComponent, AppNavigationComponent, NgClass, NgOptimizedImage, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
    private layoutService = inject(LayoutService);

    isCollapsed = signal<boolean>(true);

    constructor() {
        this.layoutService.isSidebarCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isCollapsed.set(isCollapsed);
        });
    }

    toggleIsCollapsed(): void {
        this.layoutService.toggleSidebar();
    }

    protected readonly appRoutes = AppRoutesEnum;
}
